import React from 'react';
import { Icon } from 'antd';
import { Base64 } from 'js-base64';
import RA from 'actions/dod/dodReviewActions';
import { FormField, Request, isStepValid } from 'utils/registration/formUtils';
import fields from 'utils/registration/dod/fields/reviewFields';
const f = fields;

const init = {
    status: 'invalid',
    captcha: {
        status: null,
        data: null,
        validation: null
    },
    description: 'Review & Submit',
    title: (
        <div>
            <Icon type='profile' />
            {' Step 7'}
        </div>
    ),
    forms: {
        captcha: new FormField(f.captcha)
    },
    submission: {
        json: null,
        modal: {
            show: false
        },
        request: new Request()
    }
};

export default (state=init, action) => {
    switch(action.type) {
        case RA.UPDATE_DOD_REVIEW_FIELD:
            // Narrowing scope deliberately.
            return ((s, a) => ({...s,
                status: isStepValid(s, a.payload) ? 'valid' : 'invalid',
                forms: {...s.forms, [a.payload.formProp]: a.payload }
            }))(state, action)

        case RA.UPDATE_DOD_REVIEW_TITLE:
            return {...state, title: action.payload };

        case RA.DOD_REVIEW_CAPTCHA_PENDING:
            return {...state, captcha: {...state.captcha, status: 'pending' }};

        case RA.DOD_REVIEW_CAPTCHA_SUCCESS:
            return {...state, captcha: {...state.captcha, status: 'success', data: action.payload } };

        case RA.DOD_REVIEW_CAPTCHA_FAILURE:
            return {...state, captcha: {...state.captcha, status: 'failure', data: action.payload } };

        case RA.DOD_REVIEW_CAPTCHA_RESET:
            return {...state, captcha: {...state.captcha, status: null, data: null } };

        case RA.DOD_REVIEW_CAPTCHA_VALIDATION_PENDING:
            return {...state, captcha: {...state.captcha, validation: 'pending' } };

        case RA.DOD_REVIEW_CAPTCHA_VALIDATION_SUCCESS:
            return {...state, captcha: {...state.captcha, validation: 'success' } };

        case RA.DOD_REVIEW_CAPTCHA_VALIDATION_FAILURE:
            return {...state,
                status: 'invalid',
                captcha: {...state.captcha, validation: 'failure' }
            };

        case RA.DOD_REVIEW_CAPTCHA_VALIDATION_RESET:
            return {...state,
                status: 'invalid',
                forms: {
                    captcha: new FormField(f.captcha)
                },
                captcha: {...state.captcha,
                    validation: null
                }
            };

        case RA.DOD_REVIEW_TOGGLE_SUBMISSION_MODAL:
            return {...state,
                submission: {...state.submission,
                    modal: {...state.submission.modal,
                        show: !state.submission.modal.show
                    },
                    request: action.payload
                        ? new Request()
                        : {...state.submission.request}
                }
            };

        case RA.DOD_REVIEW_SUBMISSION_RESET:
            return {...state, submission: {...state.submission, request: new Request() }};

        case RA.DOD_REVIEW_SUBMISSION_PENDING:
            return {...state, submission: {...state.submission, request: {...state.request,
                status: 'pending'
            }}};

        case RA.DOD_REVIEW_SUBMISSION_SUCCESS:
            return {...state, submission: {...state.submission, request: {...state.request,
                status: 'success'
            }}};

        case RA.DOD_REVIEW_SUBMISSION_FAILURE:
            return {...state, submission: {...state.submission, request: {...state.request,
                status: 'failure',
                code: action.payload.status
            }}};

        case RA.DOD_REVIEW_SUBMISSION_BUILDING:
            return {...state,
                submission: {...state.submission,
                    request: {...state.request,
                        status: 'building'
                    },
                    json: action.payload
                }
            };

        default: return {...state};
    }
}
